import {
  FACETS_LOCATION_NAME,
  FACETS_LOCATION_REGEX_RADIUS,
  FACETS_LOCATION_REGEX_IS_VALID,
  QUERY_PARAM_LOCATION,
  QUERY_PARAM_GEO_LOCATION_ID,
  QUERY_PARAM_PREV_LOCATION,
  QUERY_PARAM_ANY_LOCATION,
  QUERY_PARAM_DISTANCE,
  QUERY_PARAM_DATE,
  QUERY_PARAM_PAGE,
} from '../constants';
import { SET_INNER_MODAL_OPENED } from '../mutations/_types';
import { RECORD_CLICK } from '../search/actions/_types';
import { PUSH } from '../../root/actions/_types';

export default ({ defaultRadius }) =>
  (state, getters, rootState) =>
  ({
    [SET_INNER_MODAL_OPENED]: setInnerModalOpened,
    [PUSH]: push,
    [RECORD_CLICK]: recordClick,
  }) => {
    const {
      search: { facets },
      innerModalsOpened,
    } = state;
    const { 'search/filterExpanded': filterExpanded } = getters;
    const { search: searchParams } = rootState.root;

    const facet = facets.find((f) => f.name === FACETS_LOCATION_NAME) || { items: [] };
    const facetData = facet.items[0];
    const { label, browserLink } = facetData || { label: '' };

    let location = '';
    let radius = defaultRadius;
    const tmpResult = FACETS_LOCATION_REGEX_RADIUS.exec(label);
    if (tmpResult !== null) {
      [, radius] = tmpResult;
      location = label.replace(FACETS_LOCATION_REGEX_RADIUS, '').trim();
    }

    const isLocationValid = (loc) => FACETS_LOCATION_REGEX_IS_VALID.test(loc.trim());

    return {
      props: {
        modelValue: location,
        radius: Number(radius),
      },
      classes: [
        'location-search-facet',
        {
          'location-search-facet--modal-opened': innerModalsOpened[FACETS_LOCATION_NAME],
          'location-search-facet--has-location': !!location,
          'location-search-facet--hidden': !filterExpanded(FACETS_LOCATION_NAME),
        },
      ],
      on: {
        'open-modal': () => {
          setInnerModalOpened(FACETS_LOCATION_NAME, true);
        },
        'close-modal': () => {
          setInnerModalOpened(FACETS_LOCATION_NAME, false);
        },
        'update-location': (searchedString, rad, inputData) => {
          if (isLocationValid(searchedString)) {
            const nextQuery = new URLSearchParams(searchParams);

            if (inputData) {
              let googlePlaceId = null;
              const { placeId } = inputData;
              if (placeId) {
                googlePlaceId = placeId;
              } else if (inputData.place_id) {
                googlePlaceId = inputData.place_id;
              }
              nextQuery.set(QUERY_PARAM_GEO_LOCATION_ID, googlePlaceId);
            } else {
              nextQuery.set(QUERY_PARAM_LOCATION, searchedString);
            }

            nextQuery.set(QUERY_PARAM_DISTANCE, rad);

            // Ignore the following params
            nextQuery.delete(QUERY_PARAM_DATE);
            nextQuery.delete(QUERY_PARAM_PAGE);
            nextQuery.delete(QUERY_PARAM_PREV_LOCATION);
            nextQuery.delete(QUERY_PARAM_ANY_LOCATION);

            push(`?${nextQuery.toString()}`);
          }
        },
        'add-location': () => {
          recordClick({
            section: 'facets',
            linkText: 'My Location:Add a location',
          });
        },
        'change-location': () => {
          recordClick({
            section: 'facets',
            linkText: 'My Location:Change',
          });
        },
        'remove-location': () => {
          // The event is not send so record click and push the new history state
          recordClick({
            section: 'facets',
            linkText: 'My Location:Remove',
          });
          push(browserLink);
        },
        'geolocate-button': () => {
          recordClick({
            section: 'facets',
            linkText: 'My Location:geolocation requested',
          });
        },
        'radius-change': (rad) => {
          recordClick({
            section: 'facets',
            linkText: `My Location:change radius_${rad}`,
          });
        },
      },
    };
  };
